export default {
  title: "",
  subtitle: "Refund Transactions",
  path: "refund_transaction",
  paragraph: "You can refund 2 types of transactions, a non-processed one and an already processed one. The difference between them is that the first one still did not get in your internal account, so you can use this endpoint to refund it. This payment will be taken out of the real local currency account.",
  request: {
    method: "GET",
    endpoint: "/transactions/:id/refund",
    responses: {
      "data": {
        "id": "b3c5e4a6-26fc-4e3f-bb8c-91a7a8be68d5",
        "reason": null,
        "inserted_at": "2023-11-10T13:22:31.100380",
        "status": "identified",
        "transaction_kind": "2",
        "bank_transaction": {
          "id": "40ec25fa-59fd-4fac-a012-2091b16d34a3",
          "value": "184.73",
          "currency": "USD",
          "iof_value": null,
          "fx_value": null,
          "exchange_rate": null,
          "exchange_currency": "BRL",
          "exchanged_value": "1000",
          "exchange_approved": false,
          "wire_id": null,
          "exchange_id": null,
          "movement_date": "2023-11-10",
          "source_name": "Person Name",
          "source_document_number": "67645727390",
          "source_document_type": "cpf",
          "source_id": "6a9045ac-1f24-4cd9-bc88-2547d52b88d3",
          "source_type": "TED-PRE",
          "source_description": "CREDITO POR TED ANTECIPADO",
          "source_bank": null,
          "source_branch": null,
          "source_account": null,
          "source_bank_ispb": null,
          "company_id": "company-uuid",
          "company_name": "Company Name"
          }
        }
    },
  },
 troubleshooting: {
    title: 'Common mistakes',
    messages: [
       {
        description: 'Your transaction has already been identified',
        code:{
              "error": "Bank transaction associated with transaction"
          },
        solution: 'Provide a valid transaction ID'
      },
      {
        description: 'You passed a bank transaction id',
        code:{
              "errors": {
                  "bank_transaction_id": [
                      "has already been taken"
                  ]
              }
          },
        solution: 'Provide a valid transaction ID'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/RefundTransaction.js